module.exports = __webpack_public_path__ + "media/images/shared/ogp-2784f4ee6afba6e54aebbc8886368688.png";